











import Vue from 'vue'
import { Component, Emit } from 'vue-property-decorator'

@Component({})
export default class AppSortButton extends Vue {
  ascDirection = 0 // 0: null, 1: asc, 2: desc

  @Emit('sort')
  onSortChange (asc: number) {
    const { ascDirection } = this
    this.ascDirection = ascDirection === asc
      ? 0
      : asc
    return this.ascDirection === 0
      ? ''
      : this.ascDirection === 1
        ? 'asc'
        : 'desc'
  }
}
